import { useNavigate } from "react-router-dom";

export default function PostCard({ post }) {
  const navigate = useNavigate();
  const tagClass = post.category === "Announcement" ? "tg"
    : post.category === "Event" ? "tb" : "to";

  return (
    <div className="card" onClick={() => navigate(`/post/${post.id}`)}>
      {post.image
        ? <img className="card-img" src={post.image} alt={post.title}/>
        : <div className="card-img-placeholder">📰</div>
      }
      <div className="card-body">
        <span className={`tag ${tagClass}`}>{post.category}</span>
        <div className="card-date">
          {new Date(post.date).toLocaleDateString("en-PG", { year:"numeric", month:"long", day:"numeric" })}
        </div>
        <h3>{post.title}</h3>
        <p>{post.excerpt}</p>
        <div className="card-more">Read More →</div>
      </div>
    </div>
  );
}
